"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.computeSizeProp = exports.computeShapeProp = void 0;

var _devLogger = _interopRequireDefault(require("react-utils/devLogger"));

// Backwards compatibility for UIComponents/avatar/UIAvatar (HubSpot/UIComponents#4738)

/* backcompat old `shape` prop values */
var computeShapeProp = function computeShapeProp(shape) {
  if (shape === 'square') {
    _devLogger.default.warn({
      message: 'UIAvatar: `shape="square"` is deprecated. Use `shape="default"` instead.',
      key: 'UIAvatar: deprecated `shape="square"` prop value'
    });

    return 'default';
  }

  return shape;
}; // aliases for old `size` prop values


exports.computeShapeProp = computeShapeProp;
var sizePropAliases = {
  'extra-small': 'xs',
  small: 'sm',
  medium: 'md',
  large: 'lg',
  'extra-large': 'xl'
};
/** backcompat old UIAvatar `size` prop values */

var computeSizeProp = function computeSizeProp(rawSizeProp) {
  var size = sizePropAliases[rawSizeProp] || rawSizeProp;

  if (size !== rawSizeProp) {
    _devLogger.default.warn({
      message: "UIAvatar: `size=\"" + rawSizeProp + "\"` is deprecated. Use `size=\"" + size + "\"` instead.",
      key: "UIAvatar: deprecated `size=\"" + rawSizeProp + "\"` prop value"
    });
  }

  return size;
};

exports.computeSizeProp = computeSizeProp;